import theme from '@/theme';
import styled from '@emotion/styled';

const InputWrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const ValueInput = styled.input<{ suffix: string }>`
    border-radius: 8px;
    border: 1px solid ${theme.colors.black[200]};
    padding: 6px 24px 6px 4px;
    min-width: 58px;
    text-align: center;
    outline: none;
    font-size: 14px;
    text-align: end;

    padding-right: ${({ suffix }) => (suffix ? '40px' : '8px')}; /* Adjust padding based on suffix presence */
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

const Suffix = styled.span`
    position: absolute;

    right: 8px;
    top: 6px;
    width: 16px;
    pointer-events: none;
    color: ${theme.colors.black[700]};
`;
interface Props {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    suffix?: string;
}

export const ControlNumberInput = ({ value, onChange, min = 0, max = 100, suffix = '' }: Props) => {
    const handleChange = (value: number) => {
        if (isNaN(value)) return onChange(min);

        const normalizedValue = Math.min(Math.max(min, value), max);

        onChange(normalizedValue);
    };

    return (
        <InputWrapper>
            <ValueInput
                min={min}
                max={max}
                type="number"
                value={Number(value).toString()} // Remove leading zeros
                onChange={e => handleChange(parseInt(e.target.value))}
                suffix={suffix}
                onClick={e => e.currentTarget.select()}
            />
            {suffix && <Suffix>{suffix}</Suffix>}
        </InputWrapper>
    );
};
